import React, { useEffect, useContext, useState } from "react";
import { PlayerContext } from "../../context/PlayerContext";
import { getMarginTop } from "../../utils/utils";
import AlertDialog from "../generic/CustomizeAlertDilaog";
import CustomizedNestedList from "../generic/CustomizedNestedList";
import VideoRecording from "../generic/VideoRecording";
import { Button } from "@material-ui/core";
import Loader from "react-loader-spinner";
import S3Service from "../../services/S3Service";
import { RECORDING_STATUS } from "../../utils/enums";

const RecordedResponseTrack = (props) => {
  const { setShowPlayButton, showFlashAlert, isPlayingFromTrack } =
    useContext(PlayerContext);
  const [isFocused, setIsFocused] = useState(true);
  const [recordedResponseFile, setRecordedResponsFile] = useState();
  const [recordingStatus, setRecordingStatus] = useState(
    RECORDING_STATUS.not_started
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.audioURL && !props.debug && isFocused) {
      if (
        (props.alertMessage === "" && props.flashTrackId === "") ||
        !showFlashAlert
      ) {
        const clip = document.getElementById("soundclip");
        const playPromise = clip.play();
        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              console.debug("Audio play started in Recorded Response Track");
              setShowPlayButton(false);
              // Automatic playback started!
            })
            .catch(function (error) {
              console.debug(
                "Audio Play exception in Recorded Response Track :",
                error
              );
              setShowPlayButton(true, error);
            });
        }
      }
    }
    setIsFocused(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused, props.play, props.prompt]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let s3key = "";
      if (recordedResponseFile) {
        s3key = await S3Service().saveStudentRecordedResponse(
          recordedResponseFile,
          props.simId
        );
      }

      if (!props.debug) {
        setRecordedResponsFile(null);
        props.handleNextSlideWithAddAnswer([s3key], null, null, null);
      }
    } catch (error) {
      console.error("Error uploading recorded response:", error);
    } finally {
      setRecordedResponsFile(null);
      setLoading(false);
    }
  };

  const conditionalRenderingOfCssClass = () => {
    let cssClass = "";
    if (props?.trackIdx || props?.trackIdx == 0) {
      if (props?.isPub) {
        cssClass = "submit-btn-align";
      } else {
        cssClass = "submit-btn-align-unpublish";
      }
    }
    return cssClass;
  };

  const conditionalRenderingOfRecordingClass = () => {
    let cssClass = "";
    if (props?.trackIdx || props?.trackIdx == 0) {
      if (props?.isPub) {
        cssClass = "fixed-button";
      } else {
        cssClass = "fixed-button-unpublish";
      }
    }
    return cssClass;
  };

  const handleGoToFlashTrack = () => {
    props.handleGoToFlashTrack();
  };

  const handleFocus = () => {
    setIsFocused((prevState) => !prevState);
  };

  const gotoVideoPlayer = () => {
    const section = document.getElementById("videoPlayer");
    if (section && section.scrollIntoView) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      {!props.isPub && (
        <h1 style={{ marginTop: getMarginTop(props.isPub, props.trackIdx) }}>
          Track: {props.order} -- {props.title} --{" "}
          {!props.isPub && !props.debug ? props.trackId : props.id}
        </h1>
      )}
      {props.visibilitySettings.length > 0 && isPlayingFromTrack && (
        <CustomizedNestedList
          text="Variables:"
          visibilitySettings={props.visibilitySettings}
        />
      )}
      <h1 style={{ marginTop: getMarginTop(props.isPub, props.trackIdx) }}>
        {props.header}
      </h1>
      <h1 onFocus={handleFocus}>{props.prompt}</h1>
      <form>
        <VideoRecording
          setRecordedResponsFile={setRecordedResponsFile}
          isPreview={props.isPreview}
          setRecordingStatus={setRecordingStatus}
          recordingStatus={recordingStatus}
        />
        <br />
        <br />
        {!props.flashTrack && (
          <>
            <Button
              type="submit"
              color="primary"
              variant="outlined"
              className={`${conditionalRenderingOfCssClass()} pl-6`}
              onClick={handleSubmit}
              disabled={
                props.isPreview ||
                recordingStatus === RECORDING_STATUS.recording ||
                recordingStatus === RECORDING_STATUS.paused ||
                recordingStatus === RECORDING_STATUS.started
              }
            >
              Submit
            </Button>
          </>
        )}
        {!props.isPreview && (
          <Button
            className={
              props.flashTrack
                ? "fixed-button-flash"
                : conditionalRenderingOfRecordingClass()
            }
            variant="contained"
            color="primary"
            onClick={gotoVideoPlayer}
          >
            Go to Recorder
          </Button>
        )}
      </form>
      {props.audioURL && (
        <audio
          key={props.file + "_" + props.audioURL}
          id="soundclip"
          controls={props.debug}
          muted={props.isMuted}
        >
          {props.file && <source src={props.file} type="audio/mpeg" />}
          {props.audioURL && (
            <source src={props.pubAudioUrl} type="audio/mpeg" />
          )}
        </audio>
      )}
      {!props.debug &&
        !props.flashTrack &&
        showFlashAlert &&
        props.alertMessage !== "" &&
        props.flashTrackId !== "" && (
          <AlertDialog
            size="lg"
            isSticky={true}
            title={props.alertMessage}
            showGoToFlashTrack={true}
            handleGoToFlashTrack={handleGoToFlashTrack}
          />
        )}

      {loading && (
        <div className="video-player-loader">
          <div className="text-center">
            <div>
              <h1 className="text-white">
                Submitting your response. Kindly wait until the submission is
                complete.
              </h1>
              <Loader type="Bars" color="#272370" height={200} width={200} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecordedResponseTrack;
